import { Filters } from "@/models/consignado/proposal-billings.model";
import { generateCompetenciasFromToday } from "@/utils/consignado/generateCompetenciasFromToday.utils";
import { Select } from "@chakra-ui/react";

type Props = {
  dataCompetencia: string | undefined;
  setFiltersRef: React.Dispatch<React.SetStateAction<Filters>>
}

export default function CompetenciaSelect({ dataCompetencia, setFiltersRef }: Props) {
  return (
    <Select
      h="3rem"
      bg="white"
      color="black"
      width='inherit'
      fontFamily="Lexend Deca"
      fontSize="1rem"
      value={dataCompetencia ?? ""}
      onChange={(e) =>
        setFiltersRef((prev) => ({
          ...prev,
          data_competencia: e.target.value,
        }))
      }
    >
      <option value="">Selecionar Competência</option>

      {generateCompetenciasFromToday().map((item) => (
        <option key={item.competencia} value={item.competencia}>
          {item.value}
        </option>
      ))}
    </Select>
  );
}
